import { render, staticRenderFns } from "./mianshi.vue?vue&type=template&id=6dbfcd4c&scoped=true&"
import script from "./mianshi.vue?vue&type=script&lang=js&"
export * from "./mianshi.vue?vue&type=script&lang=js&"
import style0 from "./mianshi.vue?vue&type=style&index=0&id=6dbfcd4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbfcd4c",
  null
  
)

export default component.exports